<script setup>
import { CdrText } from '@rei/cedar';
import DepartureInfo from './DepartureInfo.vue';
import ReservationSelector from './ReservationSelector.vue';
import StepNavigation from './StepNavigation.vue';
import PaymentMessage from './PaymentMessage.vue';
import { useCancellationStore } from '../../stores/day-cancellation';
import cms from './data';

const cancellation = useCancellationStore();

const primary = () => {
  cancellation.stepIdx += 1;
};

const secondary = () => {
  cancellation.reset();
};
</script>

<template>
  <section class="select-reservations">
    <CdrText
      class="select-reservations__heading"
      tag="h3"
    >
      {{ cms.selectReservations.registrationHeading }}
    </CdrText>
    <DepartureInfo class="select-reservations__departure-info" />
    <CdrText
      class="select-reservations__heading"
      tag="h3"
    >
      {{ cms.selectReservations.spotCancelHeading }}
    </CdrText>
    <ReservationSelector />
    <PaymentMessage class="select-reservations__payment-message" />
    <StepNavigation
      class="select-reservations__step-navigation"
      :primary="cms.selectReservations.navigation.primary"
      :primary-disabled="
        !cancellation.reservations.selected || cancellation.reservations.selected.length === 0
      "
      :secondary="cms.selectReservations.navigation.secondary"
      :link="cms.selectReservations.navigation.link"
      @primary="primary"
      @secondary="secondary"
    />
  </section>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.select-reservations {
  max-width: 706px;
  padding-top: $cdr-space-two-x;

  &__heading {
    @include cdr-text-body-300;
  }

  &__departure-info {
    padding-top: $cdr-space-half-x;
    padding-bottom: $cdr-space-two-x;
  }

  &__payment-message {
    padding-top: $cdr-space-one-x;
  }

  &__step-navigation {
    padding-top: $cdr-space-two-x;
  }
}
</style>
